export default class Filter {
  init() {
    window.addEventListener("DOMContentLoaded", () => {
      //////////////////////////////
      // Hide After-Icon on Selected Choices
      //////////////////////////////
      const allChoices = document.querySelectorAll(
        ".choices .choices__list--single"
      );
      if (allChoices.length > 0) {
        allChoices.forEach((choice) => {
          const choiceFirstChild = choice.firstElementChild;
          if (choiceFirstChild?.getAttribute("data-value") !== "") {
            choice.closest(".choices")?.classList.add("hide-after");
          } else {
            choice.closest(".choices")?.classList.remove("hide-after");
          }
        });
      }

      //////////////////////////////
      // Handle select dropdown changes
      //////////////////////////////
      const filterForms = document.querySelectorAll("#dropdown-options");
      if (filterForms.length > 0) {
        filterForms.forEach((form) => {
          const selects = form.querySelectorAll("select");
          if (selects.length > 0) {
            selects.forEach((select) => {
              select.addEventListener("change", function () {
                const pageInput = form.querySelector('input[name="paged"]');
                if (pageInput) pageInput.value = "1";
                form.submit();
              });
            });
          }
        });
      }

      //////////////////////////////
      // Handle main filters
      //////////////////////////////
      const mainFilters = document.querySelectorAll(".main-filters .item");
      if (mainFilters.length > 0) {
        mainFilters.forEach((item) => {
          item.addEventListener("click", function (e) {
            e.preventDefault();
            if (this.href) {
              document.querySelectorAll(".main-filters .item").forEach((i) => {
                i.classList.remove("selected");
              });
              this.classList.add("selected");
              window.location.href = this.href;
            }
          });
        });
      }
    });
  }
}
